// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"7690fcb3","222":"9289e094","427":"03a36e85"}[chunkId] + ".chunk.js";
};